import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import {initializeFirestore } from "firebase/firestore";

//TODO make these env variables
const firebaseConfig = {
  apiKey: "AIzaSyCZsxg-Wux0nDEosZJvGCExi97QJtA7jqw",
  authDomain: "axial-trail-391808.firebaseapp.com",
  projectId: "axial-trail-391808",
  storageBucket: "axial-trail-391808.firebasestorage.app",
  messagingSenderId: "820047011233",
  appId: "1:820047011233:web:b5428c9d0610cdb0913fe0",
  measurementId: "G-MPPM3B2RB8"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);

export const db = initializeFirestore(app, {
    experimentalForceLongPolling: true,
    useFetchStreams: false
  });
  
export const analytics =
  db.name && typeof window !== 'undefined' ? getAnalytics(db) : null;
  

